import React from "react";
import { useLocation } from "react-router-dom";
import { PersistentToastContext } from "./PersistentToastProvider";

export const PersistentToastRouteBoundary: React.FC = () => {
  const host = React.useContext(PersistentToastContext);
  const { pathname } = useLocation();
  React.useLayoutEffect(() => { host?.navigate(pathname); }, [host, pathname]);
  return null;
};
